'use client';

import React from 'react';
import { ShieldCheck, BookOpen, Search, GraduationCap } from 'lucide-react';

export default function HeroSection() {
  const scrollToConsulta = () => {
    const section = document.getElementById('consulta-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => {
        const input = document.getElementById('query-input');
        if (input) (input as HTMLInputElement).focus();
      }, 600);
    }
  };

  return (
    <section
      className="estacio-hero estacio-hero-pattern py-12 sm:py-16 px-4 sm:px-6 relative overflow-hidden"
      aria-labelledby="hero-title"
    >
      {/* Decorative circles */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-5"
        style={{ background: 'radial-gradient(circle, #ffffff 0%, transparent 70%)', transform: 'translate(30%, -30%)' }}
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-5"
        style={{ background: 'radial-gradient(circle, #F5A623 0%, transparent 70%)', transform: 'translate(-30%, 30%)' }}
        aria-hidden="true"
      />

      <div className="max-w-screen-xl mx-auto relative z-10">
        <div className="max-w-3xl">
          {/* Eyebrow label */}
          <div className="flex items-center gap-2 mb-5">
            <div className="flex items-center gap-2 bg-white bg-opacity-15 border border-white border-opacity-25 rounded-full px-4 py-1.5">
              <ShieldCheck size={14} className="text-yellow-300" aria-hidden="true" />
              <span className="text-white text-xs font-bold uppercase tracking-widest" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Sistema de Verificação — Estácio de Sá
              </span>
            </div>
          </div>

          {/* Main heading */}
          <h2
            id="hero-title"
            className="text-white text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight mb-5"
            style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '-0.02em' }}
          >
            Validação de
            <span className="block text-yellow-300">Diplomas Digitais</span>
          </h2>

          {/* Subtitle */}
          <p
            className="text-red-100 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl"
            style={{ fontFamily: 'Open Sans, sans-serif' }}
          >
            Consulte a autenticidade de diplomas emitidos pela Estácio de Sá.
            Informe o CPF do formando ou o número do diploma para verificar o registro oficial.
          </p>

          {/* Feature pills */}
          <div className="flex flex-wrap gap-3">
            {[
              { icon: Search, label: 'Busca por CPF ou Nº do Diploma' },
              { icon: ShieldCheck, label: 'Verificação Instantânea' },
              { icon: BookOpen, label: 'Dados do Registro Acadêmico' },
              { icon: GraduationCap, label: 'Diploma Digital Oficial' },
            ]?.map((item) => (
              <button
                key={`hero-pill-${item?.label}`}
                type="button"
                onClick={scrollToConsulta}
                className="flex items-center gap-2 bg-white bg-opacity-15 border border-white border-opacity-20 rounded-full px-4 py-2 hover:bg-opacity-30 hover:scale-105 active:scale-95 transition-all duration-200 cursor-pointer"
                aria-label={`${item?.label} — ir para consulta`}
              >
                <item.icon size={13} className="text-yellow-300" aria-hidden="true" />
                <span
                  className="text-white text-xs font-semibold"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {item?.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}